/* eslint-disable import/no-unresolved */
import React, { lazy, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';

import Loader from '@/services/PageLoader';

import i18n from 'evsApp/i18n';

const LazyVerificationsTabs = lazy(() => import('evsApp/VerificationsTabs'));
const LazySingleFile = lazy(() => import('evsApp/SingleFile'));
const LazySingleLead = lazy(() => import('evsApp/SingleLead'));

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const VerificationsTabs = (props: any): JSX.Element => (
    <Suspense fallback={<Loader />}>
        <I18nextProvider i18n={i18n}>
            <LazyVerificationsTabs {...props} />
        </I18nextProvider>
    </Suspense>
);

export const EvsSingleFile = (props: any): JSX.Element => (
    <Suspense fallback={<Loader />}>
        <I18nextProvider i18n={i18n}>
            <LazySingleFile {...props} />
        </I18nextProvider>
    </Suspense>
);

export const EvsSingleLead = (props: any): JSX.Element => (
    <Suspense fallback={<Loader />}>
        <I18nextProvider i18n={i18n}>
            <LazySingleLead {...props} />
        </I18nextProvider>
    </Suspense>
);
